/** FULFILMENT METHOD — one-click choice; the screen below adapts to it. */
import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { MapPin, Map, Users, Warehouse, SplitSquareHorizontal, Hand, MoreHorizontal } from "lucide-react";
import { OpsBlock } from "./OpsTop";

const ICON = { ONE_LOCATION: MapPin, MULTIPLE_LOCATIONS: Map, DIRECT_TO_EMPLOYEES: Users, WAREHOUSE: Warehouse, PARTIAL_HOLD: SplitSquareHorizontal, CUSTOMER_PICKUP: Hand, OTHER: MoreHorizontal };

export function MethodSection({ qid, st, reload, locked }) {
  const [busy, setBusy] = useState(null);
  const pick = async (m) => {
    if (m === st.method || locked) return;
    if (st.method && !window.confirm("Change the fulfilment method? Existing recipients stay as they are.")) return;
    setBusy(m);
    try { await api.put(`/quote-operations/quotes/${qid}/method`, { method: m }); toast.success("Fulfilment method set"); reload(); } catch (e) { toast.error(e.response?.data?.detail || e.message); }
    setBusy(null);
  };
  const card = (x) => {
    const I = ICON[x.key] || MapPin, on = st.method === x.key;
    return (
      <button key={x.key} onClick={() => pick(x.key)} disabled={!!busy || locked} data-testid={`ops-method-${x.key}`} data-active={on}
        className={`flex items-center gap-2 rounded-xl border-2 px-3 text-left transition-colors ${x.primary ? "py-3" : "py-1.5"} ${on ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 bg-white text-slate-800 hover:border-slate-400"} disabled:cursor-default`}>
        <I className={`h-4 w-4 shrink-0 ${on ? "text-emerald-400" : "text-slate-400"}`} /><span className={`${x.primary ? "text-[12px] font-bold" : "text-[11px] font-semibold"} uppercase tracking-wide`}>{busy === x.key ? "Setting…" : x.label}</span>
      </button>
    );
  };
  return (
    <OpsBlock id="ops-method" title="How should this order be fulfilled?" done={!!st.method}>
      {!st.method && st.defaults?.method && <div className="mb-2 flex flex-wrap items-center gap-2 rounded-lg bg-sky-50 px-3 py-2 text-[12px] text-sky-900" data-testid="ops-method-suggest">Last time this customer used <b>{(st.methods.find((x) => x.key === st.defaults.method) || {}).label || st.defaults.method}</b>.<button onClick={() => pick(st.defaults.method)} disabled={!!busy} className="rounded-full bg-sky-700 px-3 py-1 text-[11px] font-bold text-white" data-testid="ops-method-use-last">Use the same</button></div>}
      <div className="grid grid-cols-2 gap-2 lg:grid-cols-4">{st.methods.filter((x) => x.primary).map(card)}</div>
      <div className="mt-2 flex flex-wrap gap-2">{st.methods.filter((x) => !x.primary).map(card)}</div>
    </OpsBlock>
  );
}
